define("@ember-data/debug/setup", ["exports", "@ember-data/store"], function (_exports, _store) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.typesMapFor = typesMapFor;
  0; //eaimeta@70e063a35619d71f0,"@ember-data/store"eaimeta@70e063a35619d71f
  const StoreTypesMap = new WeakMap();
  function typesMapFor(store) {
    let typesMap = StoreTypesMap.get(store);
    if (typesMap === undefined) {
      typesMap = new Map();
      StoreTypesMap.set(store, typesMap);
    }
    return typesMap;
  }

  // override _createRecordData to add the known models to the typesMap
  const __createRecordData = _store.default.prototype._createRecordData;
  _store.default.prototype._createRecordData = function (identifier) {
    const typesMap = typesMapFor(this);
    if (!typesMap.has(identifier.type)) {
      typesMap.set(identifier.type, false);
    }
    return __createRecordData.call(this, identifier);
  };
  var _default = _exports.default = {
    name: '@ember-data/data-adapter',
    initialize() {}
  };
});